<div class="flex flex-col h-full">
  <div>
    <h1>Dokumenter</h1>
  </div>
  <p-tabs
    [(value)]="dokumenterService.activeTab"
    class="flex-1 border-1 overflow-hidden">
    <p-tablist>
      <p-tab value="list"><i class="pi pi-list"></i> Liste</p-tab>
      @if (
        dokumenterService.selectedDokument() ||
        dokumenterService.mode() === 'create'
      ) {
        <p-tab value="detail"><i class="pi pi-file"></i> Detaljer</p-tab>
      }
      @if (dokumenterService.activeTab() !== 'detail') {
        <div class="mt-2 ml-8">
          <p-button
            icon="pi pi-plus"
            outlined
            label="Opret dokument"
            (click)="dokumenterService.opretDokument()"></p-button>
        </div>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="list">
        <app-letpensiondk-dokumenter-list />
      </p-tabpanel>
      <p-tabpanel value="detail">
        <app-letpensiondk-dokumenter-detail />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
